<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <b-row>
      <!-- post -->
      <b-col
          class="mx-auto"
          cols="12"
      >
        <profile-post :posts="posts"/>
      </b-col>

      <b-col
          class="mx-auto d-flex flex-row justify-content-center "
          cols="12"
      >
        <b-card>
          <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalCount"
              class="mb-2 mb-md-0 mt-1 mt-sm-0"
              first-number
              last-number
              next-class="next-item"
              prev-class="prev-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon"
                            size="18"
                            style="transform: rotate(180deg)"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </b-card>
      </b-col>
      <!-- post -->
    </b-row>

  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import ProfilePost from "@/views/pages/profile/ProfilePost";
import {PostGetAllRequest} from "@/libs/Api/Post";

export default {
  title: 'لیست پست ها - پنل ادمین نهایی شو',
  name: "PostList",
  data() {
    return {
      overlay:false,
      posts: null,
      totalCount: null,
      currentPage: 1,
      perPage: 5,
    }
  },
  watch:{
    currentPage(nv,ov){
      this.getPosts();
    }
  },
  async created() {
    await this.getPosts();
  },
  methods: {
    async getPosts() {
      let _this = this;
      _this.overlay = true;
      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage
      }
      let postGetAllRequest = new PostGetAllRequest(_this)
      postGetAllRequest.setParams(data);
      await postGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.posts = content.posts;
        _this.totalCount = content.postCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    ProfilePost,

  },
}
</script>

<style scoped>

</style>